import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { LoginService } from "mds-ui/app/shared/service/login.service";

@Component({
    selector: 'timeout-modal',
    templateUrl: './timeout-modal.component.html'
  })
  export class TimeoutModalComponent{
    constructor(
        public dialogRef: MatDialogRef<TimeoutModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string },private loginService: LoginService
      ) {}
    
      close(): void {
        this.dialogRef.close();
        window.location.href = this.loginService.getLogOutEndpoint();
      }
  }